import { useCallback, useEffect, useState } from 'react';
import { ProgressBar } from 'react-bootstrap';
import GenerateReport from '../GenerateReport';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';
import AppModal from '../../../../components/Modal/AppModal';
import _ from 'lodash';
import LoopModal from '@/layout/components/helpers/LoopModal';
import axios from 'axios';
import { axiosPath } from '@/routing/helpers/router';

const ArchieveFileModal = (props) => {
  const { moduleBridgeHex, values, setValues, onFinish } = props;

  const [pendingProfiles, setPendingProfiles] = useState(values.profiles);
  const [nextProfile, setNextProfile] = useState(null);

  const [generalModalInfo, setGeneralModalInfo] = useState({
    percent: 1,
    message: ReactDOMServer.renderToString(
      <Translator file="module-intelligence" name="preparing.information" />,
    ),
  });

  const [reportModalInfo, setReportModalInfo] = useState({
    percent: 0,
    message: '-',
  });

  const manageNextProfile = useCallback(async () => {
    const nextElement = pendingProfiles[0];

    setGeneralModalInfo({
      percent:
        5 +
        (95 / values.profiles.length) *
          (values.profiles.length - pendingProfiles.length),
      message: `${ReactDOMServer.renderToString(
        <Translator file="module-intelligence" name="creating.report" />,
      )} ${values.profiles.length - pendingProfiles.length + 1}/${
        values.profiles.length
      }`,
    });

    await axios
      .post(axiosPath('api_r_user_m_intelligence_calculateTypeIntelligence'), {
        id: nextElement,
      })
      .then(({ data }) => {
        setNextProfile({
          type: data,
          element: nextElement,
        });
      });
  }, [pendingProfiles]);

  useEffect(() => {
    if (pendingProfiles.length > 0) {
      manageNextProfile();
    } else onFinish();
  }, [pendingProfiles]);

  const handleReportInfo = (info) => {
    setReportModalInfo(info);
  };

  const handleRemoveFirstElement = () => {
    let shiftedPendingProfiles = _.cloneDeep(pendingProfiles);
    shiftedPendingProfiles.shift();
    setPendingProfiles(shiftedPendingProfiles);
    setNextProfile(null);
  };

  const onError = () => {
    setPendingProfiles(undefined);
    setNextProfile(null);
    setValues(null);
  };

  return (
    <>
      <style>
        {`
          .my-modal-dialog {
            margin-top: 13.5rem !important;
            border: 0;
            border-radius: 0;
          }
        `}

      </style>
      <AppModal
        size={'lg'}
        show
        isCloseButton={false}
        title={ReactDOMServer.renderToString(
          <Translator file="module-intelligence" name="creating.reports" />,
        )}
      >
        <p>
          <Translator file="module-intelligence" name="can.take.minutes" />
        </p>
        <h2>{generalModalInfo?.message}</h2>
        <ProgressBar variant={'success'} animated now={generalModalInfo?.percent} />
        <h4>{reportModalInfo?.message || "-"}</h4>
        <ProgressBar animated now={reportModalInfo?.percent || 0} />
      </AppModal>

      {nextProfile && (
        <>
          {nextProfile.type != 'old' ? (
            <LoopModal
              route="api_r_user_m_intelligence_calculateReportProfile"
              value={{
                values: nextProfile,
                moduleBridgeHex,
              }}
              onFinish={handleRemoveFirstElement}
              onError={onError}
              comment={values.comment}
              size="lg"
              contentClassName="my-modal-dialog"
              getModalInfo={handleReportInfo}
            />
          ) : (
            <GenerateReport
              moduleBridgeHex={moduleBridgeHex}
              values={nextProfile}
              onFinish={handleRemoveFirstElement}
              onError={onError}
              comment={values.comment}
              getModalInfo={handleReportInfo}
              route="api_r_user_m_intelligence_calculateReportProfileOld"
            />
          )}
        </>
      )}
    </>
  );
};

export default ArchieveFileModal;
